import Main from "./disco/_main";

const main = new Main();
